import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterSSDIPageDatasetList = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("ssdi/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.DataManagementPage />,
        });
      })
      .catch(reject);
  });
});

export const LazySSDIPageDatasetList = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterSSDIPageDatasetList />
    </Suspense>
  );
};
